import React, { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Bookmark, X, Mail } from "lucide-react";
import { ShortlistContext } from "@/context/ShortlistContext";
import SaveShortlistModal from "@/components/features/SaveShortlistModal";

export default function ShortlistFAB() {
  const { saved, clear } = useContext(ShortlistContext);
  const [dismissed, setDismissed] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();

  // Don't show on compare page itself
  if (location.pathname === "/compare") return null;
  if (saved.length === 0) return null;
  if (dismissed) return null;

  return (
    <div
      className="fixed bottom-8 right-8 z-50 flex items-center gap-3 animate-in"
      style={{ animation: "slideUp 0.3s ease" }}
    >
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(24px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>
      <Link
        to="/compare"
        data-testid="shortlist-fab"
        className="flex items-center gap-3 bg-fscs-ink text-white px-5 py-3.5 shadow-2xl hover:bg-fscs-coral transition-colors group"
      >
        <Bookmark size={18} className="flex-shrink-0" />
        <span className="text-sm font-medium whitespace-nowrap">
          {saved.length} saved · Compare
        </span>
        <span className="w-5 h-5 bg-fscs-coral group-hover:bg-white group-hover:text-fscs-coral text-white text-[11px] font-bold flex items-center justify-center rounded-full flex-shrink-0 transition-colors">
          {saved.length}
        </span>
      </Link>
      <button
        onClick={() => setShowModal(true)}
        className="flex items-center gap-2 bg-white text-fscs-ink px-4 py-3.5 shadow-2xl hover:bg-fscs-bg border border-fscs-border transition-colors text-sm font-medium"
      >
        <Mail size={16} /> Save for later
      </button>
      <button
        onClick={() => setDismissed(true)}
        className="bg-white border border-fscs-border text-fscs-muted hover:text-fscs-ink p-2 shadow-xl transition-colors"
        title="Dismiss"
      >
        <X size={16} />
      </button>

      {showModal && (
        <SaveShortlistModal 
          surgeons={saved} 
          onClose={() => setShowModal(false)} 
        />
      )}
    </div>
  );
}
